import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Button from "components/atoms/button";
import Text from "components/atoms/text/Text";

import { ModalContainer, ModalDescText } from "components/organisms/modal/styled";
import AbstractModal from "components/page/modal/AbstractModal";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";
import ResearchAddModal from "components/page/modal/ResearchAddModal";

import { useResearchReferencesCreate, useResearches } from "hooks/queries/useResearch";

const ContentsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 8px 0 40px 0;
    padding: 6px;
    width: 100%;
    min-height: 240px;
    max-height: 320px;
    background-color: var(--color-Base1);
    overflow: hidden;
`;

const ResearchListWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
    padding-right: 4px;
`;

const ResearchItem = styled.div`
    margin: 2px;
    padding: 4px;
    max-width: 430px;
    height: 28px;
    background-color: ${(props) => (props.selected ? "var(--color-ResearchActive)" : "var(--color-Research)")};
    border: solid 1px transparent;
    border-radius: 2px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: border 80ms ease-in;

    &:hover {
        border: solid 1px var(--color-Key);
    }
`;

const BlankView = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

const ResearchAddButtonWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 16px 0 0 0;
`;

function ReferenceCitationEditModal(props) {
    const { exitModal, citedResearches, referenceId } = props;

    const researchesQuery = useResearches();
    const [addResearchModal, setAddResearchModal] = useState(false);

    const [selectedIdList, setSelectedIdList] = useState([]);
    const [researches, setResearches] = useState([]);

    const researchReferenceCreateMutation = useResearchReferencesCreate();

    const citedResearchesRef = useRef(null);

    useEffect(() => {
        return () => {
            citedResearchesRef.current = null;
        };
    }, []);

    useEffect(() => {
        if (researchesQuery.data) {
            setResearches(researchesQuery.data);
        }
        if (citedResearchesRef.current !== citedResearches) {
            setSelectedIdList(citedResearches.map((item) => item.id));
            citedResearchesRef.current = citedResearches;
        }
    }, [researchesQuery.data, citedResearches, selectedIdList]);

    const handleCheck = (id) => {
        if (selectedIdList.includes(id)) {
            setSelectedIdList(selectedIdList.filter((item) => item !== id));
        } else {
            setSelectedIdList([...selectedIdList, id]);
        }
    };

    const handleAdd = () => {
        researchReferenceCreateMutation.mutate({
            reference_ids: [referenceId],
            research_ids: selectedIdList,
            delete_old_research: true,
        });
        exitModal();
    };

    return (
        <ModalContainer>
            <ModalDescText>이 참고문헌을 연결할 연구노트를 선택해주세요.</ModalDescText>
            <ResearchAddButtonWrap>
                <Button
                    width={"100px"}
                    height={"24px"}
                    bgColor={"var(--color-Button1)"}
                    hoverBgColor={"var(--color-ButtonHover1)"}
                    fontColor={"var(--color-White)"}
                    buttonText={"추가"}
                    onClick={(e) => setAddResearchModal(true)}
                >
                    <Icon name={"plus"} size={"12"} color={"var(--color-White)"} />
                </Button>
            </ResearchAddButtonWrap>
            <ContentsWrapper>
                {researches?.length > 0 ? (
                    <ResearchListWrap>
                        {researches.map((research, index) => (
                            <ResearchItem
                                key={index}
                                onClick={(e) => handleCheck(research.id)}
                                selected={selectedIdList.includes(research.id)}
                            >
                                <Text variant="body-sm-400" color={"var(--color-Black)"} ellipsis>
                                    {research.display_name}
                                </Text>
                            </ResearchItem>
                        ))}
                    </ResearchListWrap>
                ) : (
                    <BlankView>
                        <Text variant="body-sm-400" textAlign={"center"} color={"var(--color-DisabledText)"}>
                            아직 연구노트가 없습니다.
                        </Text>
                    </BlankView>
                )}
            </ContentsWrapper>
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"적용"}
                leftOnClick={props.exitModal}
                rightOnClick={handleAdd}
            />
            {addResearchModal && (
                <AbstractModal modalTitle="연구노트 추가" width={480} exitModal={(e) => setAddResearchModal(false)}>
                    <ResearchAddModal
                        exitModal={(e) => setAddResearchModal(false)}
                        onSuccess={(added) => {
                            handleCheck(added.id);
                            setAddResearchModal(false);
                        }}
                    />
                </AbstractModal>
            )}
        </ModalContainer>
    );
}

export default ReferenceCitationEditModal;
